<script lang="ts">
  import { BASE_URL, NUREAD_GW_URL } from '$lib/auth.svelte'
  import { Button } from '$lib/components/ui/button/index.js'
  import favicon from '$lib/assets/icons/favicon.svg'
  import overlay from '$lib/assets/overlay.png'

  let callback = `${BASE_URL}/callback`
  let source = window.location.href.replace('/login', '')
</script>

<section
  class="login-hero dark relative isolate flex min-h-dvh w-full items-center justify-center overflow-hidden px-6"
>
  <div
    class="login-hero__atmosphere absolute inset-0 bg-linear-to-br from-macchiato-base via-macchiato-mantle to-macchiato-base"
  ></div>
  <div
    class="absolute inset-0 bg-[radial-gradient(ellipse_at_30%_20%,color-mix(in_oklab,var(--color-macchiato-green)_14%,transparent),transparent_55%)]"
  ></div>
  <div
    class="login-hero__texture absolute inset-0 scale-105 bg-cover opacity-[0.12] brightness-50 blur-[2px]"
    style="background-image: url('{overlay}')"
  ></div>

  <div class="login-hero__stack relative z-[1] flex w-full max-w-sm flex-col items-center text-center sm:max-w-md">
    <div class="flex items-center gap-3 sm:gap-4">
      <img src={favicon} alt="" class="h-16 w-16 sm:h-20 sm:w-20" />
      <h1 class="text-5xl font-bold tracking-tight text-macchiato-text sm:text-6xl">
        nuread
      </h1>
    </div>

    <p class="mt-5 text-base text-macchiato-text sm:text-lg">
      Connect servers. Share shelves.<br />
      Keep reading.
    </p>

    <Button
      class="mt-10 h-14 w-full max-w-xs bg-macchiato-green text-lg font-semibold text-macchiato-base
        hover:bg-macchiato-green/90
        sm:max-w-sm"
      size="lg"
      href="{NUREAD_GW_URL}/oauth/authorize?cb={callback}&src={source}"
    >
      Connect
    </Button>
  </div>
</section>

<style>
  .login-hero__atmosphere,
  .login-hero__texture {
    animation: login-bg-in 1.1s ease-out both;
  }

  .login-hero__stack {
    animation: login-rise-in 0.75s cubic-bezier(0.22, 1, 0.36, 1) 0.08s both;
  }

  @keyframes login-bg-in {
    from {
      opacity: 0;
      transform: scale(1.08);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  @keyframes login-rise-in {
    from {
      opacity: 0;
      transform: translateY(14px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style>
